import { Event, type SubtypeTradeList } from '@kalos/kalos-rpc';
import { RpcError } from '@protobuf-ts/runtime-rpc';
import { useQuery } from '@tanstack/react-query';

import { EventClientService } from '../../tools/helpers';
import { queryKeys } from './constants';

export type SubtypeTradesFilter = {
  departmentId: number;
  jobTypeId: number;
  isResidential: number;
};

/** The trade every Sub Type routes to for this department, job type and sector; groups the Sub Type dropdown. */
export const useSubtypeTradesQuery = ({
  departmentId,
  jobTypeId,
  isResidential,
  enabled = true,
}: SubtypeTradesFilter & { enabled?: boolean }) => {
  return useQuery({
    queryKey: [queryKeys.subtypeTrades.root, departmentId, jobTypeId, isResidential],
    queryFn: async (): Promise<SubtypeTradeList | null> => {
      try {
        return await EventClientService.GetSubtypeTrades(
          Event.create({ departmentId, jobTypeId, isResidential }),
        );
      } catch (err) {
        // Backend without the RPC yet: no answer, the dropdown stays a flat list.
        if (err instanceof RpcError && err.code === 'UNIMPLEMENTED') return null;
        throw err;
      }
    },
    enabled: enabled && departmentId > 0,
    // No placeholder: the last department's grouping would be wrong for the next one, so the list
    // stays flat until this department's answer arrives.
    staleTime: 5 * 60 * 1000,
  });
};
